import React from "react";
import FavoritesCards from "../../components/favorites/favoritesCards";
import "./Favorites.css";

function Favorites() {
  return (
    <div className="favorites">
      <FavoritesCards />
    </div>
  );
}

export default Favorites;
